import { Typography } from "@material-ui/core"
import { useIntl } from 'react-intl'
import { LoginType } from '@tfo/ppl'
import { TextButton } from "@tfo/common"
import { useStore } from '../../hooks/useStore'
import { observer } from 'mobx-react'
import './ActivateBankIdInstructions.scss'


const ActivateBankIdInstructions = observer(({ setLoginType }: {
    setLoginType: (value: LoginType) => void
}) => {
    const intl = useIntl()
    const { loginStore: store } = useStore()

    const cancelActivateInstructions = () => {
        setLoginType(LoginType.None)
        store.hasNoActivatedBankId= false
    }

    return (
        <>
            <Typography variant="body1" style={{ marginBottom: '4rem' }}>
                {intl.formatMessage({ id: 'bankid.notActivated' })}
            </Typography>
            <Typography variant="body1">
                <b>
                    {intl.formatMessage({
                        id: 'bankid.wantToLoginWithBankIdHeader',
                    })}
                </b>
            </Typography>
            <ul>
                <li>
                    <Typography variant="body1">
                        {intl.formatMessage({
                            id: 'bankid.wantToLoginWithBankIdTextStepOne',
                        })}
                    </Typography>
                </li>
                <li>
                    <Typography variant="body1">
                        {intl.formatMessage({
                            id: 'bankid.wantToLoginWithBankIdTextStepTwo',
                        })}
                    </Typography>
                </li>
                <li>
                    <Typography variant="body1">
                        {intl.formatMessage({
                            id: 'bankid.wantToLoginWithBankIdTextStepThree',
                        })}
                    </Typography>
                </li>
            </ul>
            <div className="abort-container">
                <TextButton onClick={cancelActivateInstructions} className="abort-button" secondary>{intl.formatMessage({ id: 'bankid.cancelButton' })}</TextButton>
            </div>
            
        </>
    )
})

export default ActivateBankIdInstructions